// @flow
import React, { Component } from "react";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import { FormControlLabel } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import type { FieldProps } from "redux-form";

const PriceEnum = Object.freeze({
    NO: "NO",
    YES: "YES",
});

type Props = {
    inputComponent: Element,
} & FieldProps;

type State = {
    priceCheckbox: ?string,
};

class RFPriceField extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            priceCheckbox: null,
        };
    }

    handleChange = (event: SyntheticInputEvent<HTMLInputElement>): void => {
        this.setState({
            priceCheckbox: event.target.value,
        });
    };

    render() {
        const {
            input,
            meta: { touched, error },
            inputComponent,
        } = this.props;

        const { priceCheckbox } = this.state;

        return (
            <FormControl fullWidth error={!!(touched && error)}>
                <RadioGroup
                    aria-label="priceCheckbox"
                    className="form__radioButton"
                    name="priceCheckbox"
                    value={priceCheckbox}
                    onChange={event => this.handleChange(event)}
                >
                    <FormControlLabel
                        value={PriceEnum.YES}
                        control={<Radio />}
                        label="Gratuit"
                    />
                    <FormControlLabel
                        value={PriceEnum.NO}
                        control={<Radio />}
                        label="Payant"
                    />
                </RadioGroup>
                {touched && error && <FormHelperText>{error}</FormHelperText>}
                {priceCheckbox === PriceEnum.NO && (
                    <TextField
                        label="Indiquer le prix"
                        input={inputComponent}
                        {...input}
                        onChange={event => {
                            input.onChange(event.target.value);
                        }}
                        required
                        className="form__input"
                    />
                )}
            </FormControl>
        );
    }
}

export default RFPriceField;
